import styled from 'styled-components'
import { Select } from 'antd'

export const MySelect = styled(Select)<{
  $dark?: boolean
  $rounded?: boolean
  $defaultArrow?: boolean
}>`
  &:not(.ant-select-customize-input) .ant-select-selector {
    border: 2px solid
      ${props =>
        props.$dark ? props.theme['neutral-300'] : props.theme['neutral-600']};
    border-radius: ${props => (props.$rounded ? 40 : 12)}px;
    height: 40px;
    padding: 4px 16px;
    color: ${props =>
      props.$dark ? props.theme['neutral-600'] : props.theme['neutral-100']};
    background: ${props =>
      props.$dark ? 'transparent' : props.theme['neutral-800']};
    &[disabled] {
      background: ${props =>
        props.$dark ? 'transparent' : props.theme['neutral-700']};
    }
    &::placeholder {
      color: ${props =>
        props.$dark ? props.theme['neutral-400'] : props.theme['neutral-500']};
    }
    .ant-select-selection-search {
      height: 100%;
    }
  }
  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: 28px !important;
  }
  &.ant-select-lg {
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      line-height: 32px !important;
    }
  }
  &.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector {
    background: ${props =>
      props.$dark ? 'transparent' : props.theme['neutral-700']};
  }
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-right-width: 2px;
    border-color: ${props =>
      props.$dark ? props.theme['neutral-500'] : props.theme.primary};
  }
  &:not(.ant-select-disabled):hover .ant-select-selector {
    border-right-width: 2px;
    border-color: ${props =>
      props.$dark ? props.theme['neutral-500'] : props.theme.primary};
  }
  .ant-select-selection-placeholder {
    color: ${props =>
      props.$dark ? props.theme['neutral-400'] : props.theme['neutral-500']};
  }

  .ant-select-arrow {
    border: ${props =>
      props.$defaultArrow
        ? 'none'
        : `2px solid
    ${props.$dark ? props.theme['neutral-300'] : props.theme['neutral-600']}`};
    border-radius: ${props => (props.$defaultArrow ? '0px' : '32px')};
    width: ${props => (props.$defaultArrow ? 'auto' : '32px')};
    height: ${props => (props.$defaultArrow ? 'auto' : '32px')};
    line-height: 12px;
    padding: ${props => (props.$defaultArrow ? '11px 2px' : '8px')};
    margin-top: -16px;
    > span {
      color: ${props => props.theme.divider2};
    }
  }
  .ant-select-clear {
    right: 50px;
  }
`

export const MySelectDarkDropdown = styled.div`
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    color: ${props => props.theme['neutral-800']};
    background: ${props => props.theme['neutral-300']};
  }
  .ant-select-item-option-active {
    color: ${props => props.theme['neutral-800']};
    background: ${props => props.theme['neutral-200']};
  }
`
